Waves.attach('button', ['waves-button']);
Waves.attach('.btn', ['waves-button']);
Waves.attach('.navigation-item a', ['waves-button']);
Waves.attach('.collapse-item__link', ['waves-button']);
Waves.attach('.questioncontrols__content-level label', ['waves-button']);
Waves.attach('.navigation__btn', ['waves-button']);
Waves.init();



//////////////////
// WEBPACK FOOTER
// ./src/js/components/layout/_waves.js
// module id = 12
// module chunks = 0